import React from 'react';
import classnames from 'classnames';
import { REPORTS } from '../../store/reportStore'
import { withLocalize } from "react-localize-redux";
import { Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import ContactRow from './contact/contactRow';
import SourceLinks from "./SourceLinks";
import AddressRow from './identData/addressRow';
import BasicRow from './identData/basicRow';
import HistoryRow from './identData/historyRow';
import NacesRow from './identData/nacesRow';
import TradeInterruptionsRow from './identData/tradeInterruptionsRow';

import "./identData.scss";

class IdentData extends React.Component {
    state = { detailExpanded: false };


    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderContent(this.props.data, this.props.dataHash)}</div>);
    }

    renderInactiveAssociationRow = (title, hasInactiveAssociation, startDate, endDate) => {
        if (isNullOrUndefined(hasInactiveAssociation) || hasInactiveAssociation === false)
            return null;

        return (
            <div className={classnames('ident-item')}>
                <span><Translate id={title} /></span>
                <span>
                    {!isNullOrUndefined(startDate) && <><Translate id="Report.TradeInterruptions.From" /> {startDate} </>}
                    {!isNullOrUndefined(endDate) && <><Translate id="Report.TradeInterruptions.To" /> {endDate} </>}
                </span>
            </div>
        )
    }

    renderContent(data, dataHash) {
        return (
            <div className="ident-data">
                <HistoryRow name={data.companyName} from={data.from} source={data.companyNameSource} SourceFullCompany={data.companyNameSource} primaryNamesUngrouped={data.primaryNamesUngrouped} historyNames={data.historyNames} primaryNames={data.primaryNames} />
                <AddressRow address={data.fullAddress} addressSource={data.fullAddressSource} historyAddresses={data.historyAddresses} sourceFullName={data.SourceFullName} primaryAddressFrom={data.fullAddressFrom} />
                <BasicRow title="Report.CompanyIdentification.LegalForm" value={data.legalForm} />
                <BasicRow title="Report.CompanyIdentification.FactWording" value={data.factWording} />
                <BasicRow title="Report.CompanyIdentification.Ico" value={data.companyId} />
                <BasicRow title="Report.CompanyIdentification.TaxId" value={data.taxId} />
                <BasicRow title="Report.CompanyIdentification.VatId" value={data.vatId} />
                {data.vatIdForeign && <BasicRow title="Report.CompanyIdentification.VatId" value={data.vatIdForeign + " " + this.props.translate("Report.CompanyIdentification.VatIdForeign")} />}
                {data.vatIdIdentified && <BasicRow title="Report.CompanyIdentification.VatId" value={data.vatIdIdentified + " " + this.props.translate("Report.CompanyIdentification.VatIdIdentified")} />}
                <ContactRow data={data.bankAccounts} dataHash={dataHash} />
                <BasicRow title={data.taxManagerBankAccountLabel} value={data.taxManagerBankAccount} doNotTranslateTitle />
                <BasicRow title="Report.CompanyIdentification.VatPayer" value={data.isVatPayer ? this.props.translate("Common.Yes") : this.props.translate("Common.No")} />
                <BasicRow title="Report.CompanyIdentification.Lei" value={data.lei} />
                <BasicRow title="Report.CompanyIdentification.DateOfRegistration" value={data.creationDate} />
                <BasicRow title="Report.CompanyIdentification.DateOfDissolution" value={data.dissolutionDate} />
                <BasicRow title="Report.CompanyIdentification.Court" value={data.court} />
                <BasicRow title="Report.CompanyIdentification.CourtFileNumber" value={data.courtFileNumber} />
                <BasicRow title="Report.CompanyIdentification.RegistrationOffice" value={data.registrationOffice} />
                <BasicRow title="Report.CompanyIdentification.RegistrationNumber" value={data.registrationNumber} />
                <BasicRow title="Report.CompanyIdentification.RegistrationNumberUvo" value={data.registrationNumberUvo} />
                <BasicRow title="Report.CompanyIdentification.BasicCapital" value={data.basicCapital} />
                <BasicRow title="Report.CompanyIdentification.EmployeeRange" value={data.employeeRange} />
                <BasicRow title="Report.CompanyIdentification.TurnoverRange" value={data.turnoverRange} />
                <BasicRow title="Report.CompanyIdentification.StateSu" value={data.companyUnits} dataType="array" />
                <BasicRow title="Report.CompanyIdentification.Department" value={data.companyCentralAuthorities} dataType="array" />
                <BasicRow title="Report.CompanyIdentification.Ownership" value={data.companyOwnerships} dataType="array" />
                <BasicRow title="Report.CompanyIdentification.InstSector" value={data.instSector} />
                <BasicRow title="Report.CompanyIdentification.InstitutionalSubject" value={data.companySectors} dataType="array" />
                <NacesRow title="Report.CompanyIdentification.PrimaryNace" naces={data.primaryNaces} />
                <BasicRow title="Report.CompanyIdentification.TradeCreation" value={data.tradeCreation} />
                {this.renderInactiveAssociationRow("Report.CompanyIdentification.InactiveAssociation", data.inactiveAssociation, data.inactiveAssociationStartDate, data.inactiveAssociationEndDate)}
                <TradeInterruptionsRow title='Report.TradeInterruptions' data={data.tradeInterruptions} breakStart={data.breakStartFormated} breakEnd={data.breakEndFormated} />
                {this.props.reportType === REPORTS.short && <SourceLinks sourceLinks={data.SourceList} />}
            </div>
        )
    }
}

export default withLocalize(IdentData);
